var map = {
	"./accessibility.svg": 37576,
	"./add-alt.svg": 84875,
	"./add-comment.svg": 39805,
	"./add.svg": 35990,
	"./arrow.svg": 34027,
	"./calendar.svg": 84746,
	"./check.svg": 90624,
	"./chevron.svg": 71817,
	"./close.svg": 92972,
	"./document-blank.svg": 51790,
	"./download.svg": 69256,
	"./edify/dashboard.svg": 84422,
	"./edify/news.svg": 31551,
	"./edify/notification.svg": 49075,
	"./edifycalendar.svg": 25961,
	"./edit-filter.svg": 60983,
	"./edit.svg": 43916,
	"./ellipsis-vertical.svg": 68424,
	"./email.svg": 86784,
	"./event.svg": 42496,
	"./external.svg": 4029,
	"./eye.svg": 76839,
	"./facebook.svg": 25404,
	"./favorite.svg": 37924,
	"./file-anyfile.svg": 42789,
	"./file-circle-plus.svg": 64976,
	"./file-doc.svg": 28955,
	"./file-image.svg": 51194,
	"./file-pdf.svg": 54267,
	"./file-ppt.svg": 82429,
	"./file-xls.svg": 99350,
	"./generic-file.svg": 33114,
	"./grid.svg": 1496,
	"./home.svg": 28493,
	"./information.svg": 88194,
	"./link-hover.svg": 35277,
	"./list.svg": 1984,
	"./logo-facebook.svg": 60374,
	"./logo-instagram.svg": 34610,
	"./logo-linkedin.svg": 97236,
	"./logo-twitter-x.svg": 68092,
	"./logo-twitter.svg": 20867,
	"./logo-uni.svg": 47636,
	"./logo-youtube.svg": 13385,
	"./map.svg": 47242,
	"./menu.svg": 67373,
	"./ms-excel-document.svg": 92968,
	"./ms-powerpoint-document.svg": 69116,
	"./ms-word-document.svg": 58625,
	"./next-outline.svg": 26886,
	"./overflow-menu.svg": 65674,
	"./pause.svg": 45462,
	"./pdf-file.svg": 4021,
	"./phone.svg": 70452,
	"./play.svg": 98294,
	"./scroll-me.svg": 28526,
	"./search.svg": 48836,
	"./send.svg": 23570,
	"./subtract-alt.svg": 21202,
	"./subtract.svg": 69812,
	"./time.svg": 34123,
	"./user-avatar.svg": 93969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21319;